import { SendEmailAction } from '../../../redux/actions/email';

export const sendEmail = (
  userInfo,
  monthName,
  thisYear,
  totalValueCnpj1,
  totalValueCnpj2,
  totalValue,
  projects,
  files,
  dispatch,
) => {
  let indexCnpj1 = 0;
  let indexCnpj2 = 0;
  let title = `Faturamento - ${userInfo.name} - ${monthName}/${thisYear}`;
  let html = `
  <h4 style="margin: 5px 0px;">Nome do Colaborador: <strong>${userInfo.name}</strong></h4>
  <p style="margin: 5px 0px;">Mês/ano referente: <strong>${monthName}/${thisYear}</strong></p>
  <p style="margin: 5px 0px;">Valor de Declaração para Sincroniza Educação: <strong>${totalValueCnpj1.toLocaleString(
    'pt-br',
    {
      style: 'currency',
      currency: 'BRL',
    },
  )}</strong></p>
  <p style="margin: 5px 0px;">Valor de Declaração para Sincroniza Projetos: <strong>${totalValueCnpj2.toLocaleString(
    'pt-br',
    {
      style: 'currency',
      currency: 'BRL',
    },
  )}</strong></p>
  <p style="margin: 5px 0px;">Valor total a receber: <strong>${parseInt(totalValue, 10).toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  })}</strong></p>
  <p>CNPJ 1</p>
  <table style="text-align: center; border-collapse: collapse;">
    <thead style="border: 1px solid #000; padding: 4px;">
      <tr style="border: 1px solid #000; padding: 4px;">
        <th style="border: 1px solid #000; padding: 4px;">Nº</th>
        <th style="border: 1px solid #000; padding: 4px;">Cliente - Projeto</th>
        <th style="border: 1px solid #000; padding: 4px;">Rateio</th>
        <th style="border: 1px solid #000; padding: 4px;">Valor(R$)</th>
      </tr>
    </thead>
    <tbody style="border: 1px solid #000; padding: 4px;">
    ${projects.map((project, index) => {
      if (project.cnpj === '1') {
        indexCnpj1 += 1;
        return `<tr key={project-${index + 1}} style="border: 1px solid #000; padding: 4px;">
        <td style="border: 1px solid #000; padding: 4px;">${indexCnpj1}</td>
        <td style="border: 1px solid #000; padding: 4px;">${project.clientAndProject}</td>
        <td style="border: 1px solid #000; padding: 4px;">${project.rateio}%</td>
        <td style="border: 1px solid #000; padding: 4px;">${project.value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })}</td>
        </tr>`;
      }
    })}
    </tbody>
  </table>
  <br />
  <p>CNPJ 2</p>
  <table style="text-align: center; border-collapse: collapse;">
    <thead style="border: 1px solid #000; padding: 4px;">
      <tr style="border: 1px solid #000; padding: 4px;">
        <th style="border: 1px solid #000; padding: 4px;">Nº</th>
        <th style="border: 1px solid #000; padding: 4px;">Cliente - Projeto</th>
        <th style="border: 1px solid #000; padding: 4px;">Rateio</th>
        <th style="border: 1px solid #000; padding: 4px;">Valor(R$)</th>
      </tr>
    </thead>
    <tbody style="border: 1px solid #000; padding: 4px;">
    ${projects.map((project, index) => {
      if (project.cnpj === '2') {
        indexCnpj2 += 1;
        return `<tr key={project-${index + 1}} style="border: 1px solid #000; padding: 4px;">
        <td style="border: 1px solid #000; padding: 4px;">${indexCnpj2}</td>
        <td style="border: 1px solid #000; padding: 4px;">${project.clientAndProject}</td>
        <td style="border: 1px solid #000; padding: 4px;">${project.rateio}%</td>
        <td style="border: 1px solid #000; padding: 4px;">${project.value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })}</td>
        </tr>`;
      }
    })}
    </tbody>
  </table>
  <p>Itens anexados: </p>
  ${files.map((fileArray) => `<a href="${fileArray.url}">${fileArray.name}</a><br />`)}
  `;
  dispatch(SendEmailAction(html, title));
};
